import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import { getSortedCountryLabels, initialCountriesFilter } from "./FilterTypes/CountryFilterType";
import FilterPopup from "../FilterPopup";
import Country from "./AddressFilters/Country";
import { ButtonPrimary } from "components/Atoms/Button";

const CountryFilter = () => {
  const title = RESX.Address.Country;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("country", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedCountryLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedCountries.length > 0,
    reset: () => initialCountriesFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedCountries.map(c => c.key).sort(), b.selectedCountries.map(c => c.key).sort())
  });
  useEffect(() => {
    setInitialValue("country", initialCountriesFilter);
  }, []);

  const [selectedCountries, setSelectedCountries] = React.useState<server.dto.Country[]>(initialCountriesFilter.selectedCountries);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedCountries(getValue("country").selectedCountries);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("country", {
      selectedCountries,
    });
    setPopupOpen(false);
  };

  const onCountryAdded = (country: server.dto.Country) => {
    const newCountries = [...selectedCountries, country];
    setSelectedCountries(newCountries);
    // applyRef?.current?.focus();
  };

  const onCountryRemoved = (country: server.dto.Country) => {
    const newCountries = selectedCountries.filter(c => c.key !== country.key);
    setSelectedCountries(newCountries);
  };

  return <div>
    <FilterPopup
      width={272}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      filterButtonLabel={title}
      content={<form onSubmit={onApply} >
        <Country value={selectedCountries} onAdd={onCountryAdded} onRemove={onCountryRemoved} />

        <div className="margin-top">
          <ButtonPrimary fluid htmlType="submit" label={RESX.SelectionManager.Apply} />
        </div>
      </form>}
    />
  </div>
};

export default CountryFilter;
